import { Card } from '@mui/material';
import { useSearchParams, useNavigate } from 'react-router-dom';
import useBudgetVersion from '../hooks/useBudgetVersion';
import CreateBudget from '../../createAndEdit';
import DetailBudget from '../../detail';
import { Loading } from '../../../../utils/loading';
import { useBudgetActions } from '../../hooks/useBudgetActions';
import { BudgetRecipientEnum } from '../../createAndEdit/types';

const BudgetVersion = (props: any) => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const redirectBackFromParams = searchParams.get('redirectBack');
    const { budgetVersion, budget, viewMode, loading, afterSave } = useBudgetVersion({ mainRoute: `/${props.persona}/budgets-kanban` });

    const { handleAcceptBudget, handleRejectBudget } = useBudgetActions({
        currentBudgetId: budgetVersion?.budgetId || null,
        budgetsListResponse: null,
        budgetFormData: budgetVersion,
        userProfile: BudgetRecipientEnum.MANAGER,
        versionNumber: budgetVersion?.versionNumber,
        onSuccess: afterSave,
    });
    
    const defaultRedirectBack = `/${props.persona}/budgets`;
    const redirectBack = redirectBackFromParams || (viewMode === 'create' ? defaultRedirectBack : undefined);

    const handleClose = () => {
        if (redirectBack) {
            navigate(redirectBack);
        } else {
            afterSave();
        }
    };

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <Loading label="Carregando orçamento..." />
            </div>
        );
    }

    return (
        <Card className="p-8 my-4 !bg-white dark:!bg-neutral-900 dark:!text-neutral-100">
            {viewMode === 'update' || viewMode === 'create' ?
                <CreateBudget
                    mode={viewMode === 'create' ? 'create' : 'edit'}
                    budgetId={budgetVersion?.budgetId || 'budget-' + Date.now()}
                    initialData={budgetVersion || undefined}
                    occurrenceId={budgetVersion?.occurrenceId}
                    onSave={afterSave}
                    onClose={redirectBack ? handleClose : undefined}
                    redirectBack={redirectBack}
                />
            :
            <DetailBudget
                occurrenceId={budgetVersion?.occurrenceId || ''}
                budgetId={budgetVersion?.budgetId || ''}
                initialData={budgetVersion || undefined}
                budgetStatus={budget?.status}
                onClose={redirectBack ? handleClose : undefined}
                redirectBack={redirectBack || undefined}
                onAccept={handleAcceptBudget}
                onReject={handleRejectBudget}
            />}
        </Card>
    );
};

export default BudgetVersion;